'use client';

import { useState } from 'react';
import { IconShareProduct } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import ShareModal from './share-modal';
export default function ShareButton() {
  const {
    isMobile
  } = useMobileDetect();
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);
  const handleClick = () => {
    if (!isMobile) {
      setIsOpen(true);
      return;
    }
    if (navigator && typeof navigator.share === 'function') {
      navigator.share({
        url: window.location.href
      });
    } else {
      setIsOpen(true);
    }
  };
  return <>
            <IconShareProduct className='h-6 w-6 cursor-pointer text-text-mediumGray' onClick={handleClick} data-sentry-element="IconShareProduct" data-sentry-source-file="share-button.tsx" />

            {isOpen && <ShareModal handleClose={handleClose} />}
        </>;
}